export default __webpack_public_path__ + "static/media/CellTheory.613f335b.jpg";